import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css?raw';
import 'react-day-picker/lib/style.css?raw';
import 'slick-carousel/slick/slick.css?raw';
import 'slick-carousel/slick/slick-theme.css?raw';
import 'rc-time-picker/assets/index.css?raw';
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css?raw';

import './assets/css/global.css?raw';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js